import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { API, PRODUCT_TYPES } from '@apps/api-interfaces';
import { getCookie } from '@apps/tools';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';
export class AgentService {
    constructor(http, router) {
        this.http = http;
        this.router = router;
    }
    log(view, data = this.getCurrentLogDetails(), cid = getCookie('cid')) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!cid || !view) {
                return false;
            }
            const url = `${API.LOGS}/${cid}/${view}`;
            return yield this.http
                .post(url, data)
                .pipe(catchError(() => of(false)))
                .toPromise();
        });
    }
    getPixel(cid = getCookie('cid')) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!cid) {
                return undefined;
            }
            const url = `${API.USER_SETTINGS}/cid/${cid}`;
            return yield this.http
                .get(url)
                .pipe(map(e => e && e.trackingPixel))
                .toPromise();
        });
    }
    getCurrentLogDetails() {
        const data = {};
        if (document.referrer && document.referrer.indexOf('https://zatrzymajlicznik.pl') !== 0 && document.referrer.indexOf('http://localhost') !== 0) {
            data.referral = document.referrer;
        }
        const path = this.router.url.split('/');
        if (PRODUCT_TYPES.map(e => e.id).includes(path[1])) {
            data.product = path[1];
        }
        return data;
    }
}
